import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import {
    FormGroup,
    FormControl,
    Validators,
    AbstractControl
} from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { MessageComponent, BaseComponent } from '../common/common-components';
import { DictionaryService } from "../services/dictionary-service";
import { BankAccountService } from "../accounts/bank-account-service";
import { MessageService } from "../services/message-service";
import { WalletService } from "./wallet-service";
import { ModalService } from "../services/modal-service";
import { UserService } from "../user/user-service";
import {IDropdownItem} from "../types/dropdown-item";
declare var ga: any;
declare var DobryKantor: any;

let _: any = require("lodash");

@Component({
    selector: 'dk-wallet-withdraw',
    inputs: ['id'],
    template: require('./wallet-withdraw.html'),
    entryComponents: [],
    providers: [DictionaryService, BankAccountService, WalletService, UserService]
})

export class WalletWithdrawComponent extends BaseComponent implements OnInit {
    public id: number;
    public errorMessageId: string;

    public currencies: any[];
    public bankCodes: any[];
    public purposes: any[];
    public resultCurrencyStateAmount: any;
    public exchangeAmount: any;
    public cantorBankCodeId: any;
    public transaction: any;
    public isActive: boolean = true;
    public viewNumber: number = 1;
    public summaryDataAccount: any;
    public summaryDataCurrency: any;
    public currencyName: any;
    public isReady: boolean = false;
    public loaded: boolean = false;
    public commissionAmount: number = 0;
    public showCommission: boolean = false;
    public withdrawalAmount: number = 0;
    public maxAmount: number = 0;
    public smsCode: any;
    public showCostOption = false;
    public showTimeOption = false;
    public timeOptions: IDropdownItem[];
    public costOptions: IDropdownItem[];
    public isTransBlocked: boolean = false;
    public personalData: boolean = false;
    public isEmptyBalance: boolean = true;
    public firstExchangeUrl: string;
    public showThirdPartyTransferAccept: boolean = false;
    public isThirdParty: boolean = false;
    public purposeLimit: number = null;


    form: FormGroup = new FormGroup({
        CurrencyId: new FormControl(null, Validators.required),
        Amount: new FormControl(null, [Validators.required, this.checkMaxAmount()]),
        BankCodeId: new FormControl(null, Validators.required),
        TransferTitle: new FormControl('', [Validators.required, Validators.minLength(1), Validators.maxLength(120)]),
        SmsCode: new FormControl(''),
        TimeOption: new FormControl('0', Validators.required),
        CostOption: new FormControl('0', Validators.required),
        ThirdPartyTransferAccepted: new FormControl(false),
        TransferPurpose: new FormControl(''),
        TransferPurposeTxt: new FormControl('')
    });

    constructor(private dictionaryService: DictionaryService, private messageService: MessageService,
        private bankAccountService: BankAccountService, private route: ActivatedRoute,
        private walletService: WalletService, private modalService: ModalService,
        private userService: UserService) {
        super();
    }

    checkMaxAmount() {
        return (c: FormControl) => {
            if (this.form) {
                return c.value <= this.maxAmount ? null : {
                    checkMaxAmount: {
                        valid: false,
                    }
                };
            }
        }
    }

    next() {
        if (this.viewNumber != 1){
            return;
        }
        
        this.touchFormGroup(this.form);
        if (this.form.valid) {
            this.transaction = this.form.value;
            this.errorMessageId = null;
            this.viewNumber = 2;
            this.summaryDataAccount = _.find(this.bankCodes, q => q.BankCodeID == this.transaction.BankCodeId);
            this.summaryDataCurrency = _.find(this.currencies, q => q.Id == this.transaction.CurrencyId);
            this.currencyName = _.split(this.summaryDataCurrency.Name, ',', 1)[0];
            if(this.maxAmount-this.form.controls['Amount'].value < this.commissionAmount){
                this.withdrawalAmount = this.maxAmount - this.commissionAmount;

            } else {
                this.withdrawalAmount = this.form.controls['Amount'].value;
            }
        }
    }

    back() {
        this.viewNumber = 1;
    }

    confirm() {
        this.touchFormGroup(this.form);
        if (this.form.valid) {
            this.transaction = this.form.value;
            this.errorMessageId = null;

            this.walletService.isSmsNeededForTransactionAction(this.transaction.BankCodeId).subscribe(isSmsNeeded => {
                if (isSmsNeeded) {
                    this.modalService.sendSmsCode();
                    this.form.controls['SmsCode'].setValue('');
                    this.viewNumber = 3;
                    return;
                }
                this.bankAccountService.getMatchingCantorBankId(this.transaction.BankCodeId).subscribe(result => {
                    this.cantorBankCodeId = result[0].CantorBankCodeID;
                    let item = {
                        CurrencyId: this.transaction.CurrencyId,
                        Amount: this.transaction.Amount,
                        AccountBankCodeId: this.transaction.BankCodeId,
                        CantorBankCodeId: this.cantorBankCodeId,
                        TransferTitle: this.form.controls['TransferTitle'].value,
                        TimeOpt: this.form.controls['TimeOption'].value,
                        CostOpt: this.form.controls['CostOption'].value,
                        ThirdPartyTransferAccepted: this.form.controls['ThirdPartyTransferAccepted'].value,
                        TransferPurpose: this.form.controls['TransferPurposeTxt'].value
                    };
                    this.walletService.createTransactionWithdrawal(item).subscribe(() => {
                        this.viewNumber = 4;
                        ga('send', 'event', 'portfel', 'wypłata', this.currencyName, item.Amount, item);
                    }, (error) => {
                        this.errorMessageId = error.messageId;
                    });
                })
            });
        }
    }

    confirmWithSms() {
        this.touchFormGroup(this.form);

        if (this.form.valid) {
            this.transaction = this.form.value;
            this.errorMessageId = null;

            this.bankAccountService.getMatchingCantorBankId(this.transaction.BankCodeId).subscribe(result => {
                this.cantorBankCodeId = result[0].CantorBankCodeID;
                let item = {
                    CurrencyId: this.transaction.CurrencyId,
                    Amount: this.transaction.Amount,
                    AccountBankCodeId: this.transaction.BankCodeId,
                    CantorBankCodeId: this.cantorBankCodeId,
                    TransferTitle: this.form.controls['TransferTitle'].value,
                    TimeOpt: this.form.controls['TimeOption'].value,
                    CostOpt: this.form.controls['CostOption'].value,
                    ThirdPartyTransferAccepted: this.form.controls['ThirdPartyTransferAccepted'].value,
                    TransferPurpose: this.form.controls['TransferPurposeTxt'].value
                };
                let code = this.form.controls['SmsCode'].value;
                this.walletService.createTransactionWithdrawal(item, code).subscribe(() => {
                    this.viewNumber = 4;
                    ga('send', 'event', 'portfel', 'wypłata', this.currencyName, item.Amount, item);
                }, (error) => {
                    this.errorMessageId = error.messageId;
                    this.viewNumber = 2;
                });
            })
        }
    }

    loadCommission() {
        if(!this.form.controls['BankCodeId'].value) return;
        this.bankAccountService.getMatchingCantorBankId(this.form.controls['BankCodeId'].value).subscribe(result => {
            this.cantorBankCodeId = result[0].CantorBankCodeID;
            this.walletService.loadCommission(
                null,
                this.form.controls['CurrencyId'].value,
                this.form.controls['CurrencyId'].value,
                this.cantorBankCodeId,
                this.form.controls['BankCodeId'].value,
                this.form.controls['Amount'].value,
                this.showTimeOption ? this.form.controls['TimeOption'].value : "0",
                this.showCostOption ? this.form.controls['CostOption'].value : "0").subscribe(result => {
                    this.showCommission = result != 0;
                    this.commissionAmount = result;
                });
        });
    }

    loadOptions(bankCodeId: number) {
        let bankCode = _.find(this.bankCodes, q => q.BankCodeID == bankCodeId);
        this.showCostOption = bankCode.CostOpt === 1;
        this.showTimeOption = bankCode.TimeOpt === 1;
        this.isThirdParty = bankCode.ThirdParty === 1;
        this.showThirdPartyTransferAccept = this.isThirdParty;
    }

    public get getTransferTitle(): any {
        return this.form.controls['TransferTitle'].value;
    }

    public ngOnInit() {
        this.timeOptions = [];

        this.timeOptions.push({
            Id: "0",
            Name: "standard"
        });

        this.timeOptions.push({
            Id: "1",
            Name: "ekspres"
        });

        this.costOptions = [];

        this.costOptions.push({
            Id: "0",
            Name: "SHA"
        });

        this.costOptions.push({
            Id: "1",
            Name: "OUR"
        });

        this.bankAccountService.isAccountActive().subscribe(result => {
            this.isActive = result;
        });

        this.bankAccountService.isAccountReadyForWithdrawal().subscribe(result => {
            if(result==2){
                this.isTransBlocked = true;
                this.isReady = false;
            } else {
                this.isReady = result;
            }
            this.loaded = true;
        });

        this.walletService.masterCurrencies().subscribe(result => {
            if (result.length == 0)
                return;

            this.currencies = result;
            let currencyId = this.route.snapshot.params['currencyId'];
            if (currencyId) {
                this.form.controls['CurrencyId'].setValue(currencyId);
            } else {
                this.form.controls['CurrencyId'].setValue(result[0].Id);
            }
        });

        this.userService.accountInfo().subscribe(result => {
            this.personalData = result;
        });

        this.walletService.isEmptyBalance().subscribe(result => {
            this.isEmptyBalance = result;
        });

        this.form.controls['CurrencyId'].valueChanges.subscribe(newValue => {
            this.maxAmount = _.find(this.currencies, q => q.Id == newValue).Amount;
            this.form.controls["Amount"].updateValueAndValidity();
            let tempName = _.find(this.currencies, q => q.Id == newValue).Name;
            this.currencyName = _.split(tempName, ',', 1)[0];
            this.bankAccountService.bankCodesForCurrency(newValue).subscribe(bankCodes => {
                this.bankCodes = bankCodes;
                let bankCodeId = bankCodes[0].BankCodeID;
                this.form.controls['BankCodeId'].setValue(bankCodeId);
                this.loadOptions(bankCodeId);
                this.purposeLimit = bankCodes[0].purposeLimit;
            });
        });

        this.walletService.title(5).subscribe(result => {
            this.form.controls['TransferTitle'].setValue(result);
        });

        this.form.controls['BankCodeId'].valueChanges.subscribe(value => {
            this.loadCommission();
            this.loadOptions(value);
            this.loadPurposeIfNeeded();
        });
        
        this.form.controls['TimeOption'].valueChanges.subscribe(value => {
            this.loadCommission();
        });
        
        this.form.controls['CostOption'].valueChanges.subscribe(value => {
            this.loadCommission();
        });
        
        this.form.controls['Amount'].valueChanges.subscribe(value => {
            this.loadCommission();
            this.loadPurposeIfNeeded();
        });

        this.firstExchangeUrl = DobryKantor.params.cantor.firstExchangeUrl;
    }

    public exchangeEverything() {
        this.form.controls['Amount'].setValue(this.maxAmount);
    }

    isPurposeTxtVisible(){
        return this.isPurposeVisible() && this.purposes && this.form.controls['TransferPurpose'].value == 6;
    }
    isPurposeVisible(){
        return this.isThirdParty && this.form.controls['Amount'].value>=this.purposeLimit;
    }

    loadPurposeIfNeeded(){
        if(this.isPurposeVisible()){
            this.dictionaryService.transferPurposes().subscribe(result => {                
                this.setRequired(this.form.controls['TransferPurpose'], true);
                this.setRequired(this.form.controls['TransferPurposeTxt'], true);
                this.purposes = result;
                
                this.form.controls['TransferPurpose'].valueChanges.subscribe(purposeId => {
                    const selectedPurpose = this.purposes.find(purpose => purpose.Id == purposeId);
                    if (selectedPurpose && purposeId != 6) {
                        this.form.controls['TransferPurposeTxt'].setValue(selectedPurpose.Name);
                    } else {
                        this.form.controls['TransferPurposeTxt'].setValue('');
                    }
                });
            })
            
        } else {
            this.setRequired(this.form.controls['TransferPurpose'], false);
            this.setRequired(this.form.controls['TransferPurposeTxt'], false);
        }
    }

    setRequired(ctrl: AbstractControl, value: boolean){
        if(value){
            ctrl.setValidators(Validators.required);
        } else {
            ctrl.clearValidators();
        }
        ctrl.updateValueAndValidity();
    }
}
